import { ConstantsClinic, ConstantsCMSUI, ConstantsPIMS } from '../environments.model';
import {
  CONSTANTS_CLINIC,
  CONSTANTS_CMS_UI,
  CONSTANTS_PIMS,
  SHARED_ENVIRONMENT_API_URLS,
  SHARED_ENVIRONMENT_KEYS,
} from './constants.base';

export const constantsDevPIMS: ConstantsPIMS = {
  ...CONSTANTS_PIMS,
  ...SHARED_ENVIRONMENT_KEYS.dev,
  ...SHARED_ENVIRONMENT_API_URLS.dev,
  version: `${CONSTANTS_PIMS.version}-DEV`,
  PRESCREENED_ENABLED: 'FALSE',
  ENV: 'devphp8',
  url: 'https://dev-ecs-pims.lemonaidpims.co.uk',
  PIMS_FONTS: 'https://d1azc1qln24ryf.cloudfront.net/82534/PIMS/style-cf.css?j7xjuh',
  CMS_API_URL: 'https://dev-cms-api.lemonaidpims.co.uk',
  API_URL: 'https://ecs-api-pims.lemonaidpims.co.uk/v2.0',
  ADMIN_API_URL: 'https://ecs-api-pims.lemonaidpims.co.uk:2053/v2.0',
  CMS_URL: 'https://dev-cms.lemonaidpims.co.uk/',
  DOSESPOT_KEY: '',
  DOSESPOT_SIGN_ON: '',
  DOSESPOT_API: '',
  DOSESPOT_CLINIC_ID: '',
  serverless_tracking_api_url: 'https://dev-sapi.lemonaidpims.co.uk/',
};

export const constantsDevCMSUI: ConstantsCMSUI = {
  ...CONSTANTS_CMS_UI,
  ...SHARED_ENVIRONMENT_API_URLS.dev,
  version: `${CONSTANTS_CMS_UI.version}-DEV`,
  ENV: 'dev',
  url: 'https://dev-ecs-pims.lemonaidpims.co.uk',
  API_URL: 'https://dev-cms-api.lemonaidpims.co.uk/',
  PIMS_FONTS: 'https://d1azc1qln24ryf.cloudfront.net/82534/PIMS/style-cf.css?j7xjuh',
  PIMS_API: 'https://ecs-api-pims.lemonaidpims.co.uk:2053/v2.0/',
  PIMS_URL: 'https://dev-ecs-pims.lemonaidpims.co.uk/',
};

export const constantsDevClinic: ConstantsClinic = {
  ...CONSTANTS_CLINIC,
  ...SHARED_ENVIRONMENT_KEYS.dev,
  ...SHARED_ENVIRONMENT_API_URLS.dev,
  env: 'beta',
  platform: 'web',
  version: '2.0.0',
  domain: 'lemonaidhealth.co.uk',
  assets_url: 'https://assets.lemonaidhealth.co.uk/',
  clinic_url: 'https://dev-ecs-clinic.lemonaidhealth.co.uk/',
  brochure_url: 'https://dev-brochure.lemonaidhealth.co.uk/',
  api_url: 'https://ecs-api-pims.lemonaidpims.co.uk/v2.0/',
  partner_labs_url: 'https://ecs-api.lemonaidpims.co.uk/',
  payment_url: 'https://dev-payment-api-pims.lemonaidpims.co.uk/v2.0/',
  lemonaid_font: 'https://d1azc1qln24ryf.cloudfront.net/82534/LemonaidWesbite/style-cf.css?l03fso',
  boots_font: 'https://d1azc1qln24ryf.cloudfront.net/82534/Boots/style-cf.css?j360k6',
  ga_id: '',
  google_maps: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
  addressnow_capture_key: 'ac73-hj33-hf22-ch11',
  ADMIN_API_URL: 'https://ecs-api-pims.lemonaidpims.co.uk:2053/v2.0',
  serverless_tracking_api_url: 'https://dev-sapi.lemonaidpims.co.uk/',
  script_assist_app_url: 'https://boots-staging-patient.scriptassist.co.uk/sso/entry?scope=CLINIC&prompt=none',
};
